function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#4A90E2"
}, React.createElement("circle", {
  cx: 59,
  cy: 59,
  r: 59
}), React.createElement("path", {
  d: "M109.567 113.567l-28-7.236 20.764-20.764z"
})), React.createElement("g", {
  transform: "translate(13 21)",
  fill: "#FFF"
}, React.createElement("rect", {
  y: 29,
  width: 8,
  height: 18,
  rx: 4
}), React.createElement("rect", {
  x: 12,
  y: 18,
  width: 8,
  height: 40,
  rx: 4
}), React.createElement("rect", {
  x: 24,
  width: 8,
  height: 76,
  rx: 4
}), React.createElement("rect", {
  x: 36,
  y: 13,
  width: 8,
  height: 50,
  rx: 4
}), React.createElement("rect", {
  x: 48,
  y: 34,
  width: 8,
  height: 8,
  rx: 4
}), React.createElement("rect", {
  x: 60,
  y: 34,
  width: 8,
  height: 8,
  rx: 4
}), React.createElement("rect", {
  x: 72,
  y: 34,
  width: 8,
  height: 8,
  rx: 4
}), React.createElement("rect", {
  x: 84,
  y: 34,
  width: 8,
  height: 8,
  rx: 4
})));

const SvgNotificationIcon = (_ref) => {
  let {
    svgRef
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 118,
    height: 118,
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgNotificationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NotificationIcon.c6820e5f.svg";
export { ForwardRef as ReactComponent };